<template>
  <div class="goods-info-labels">
    <div class="label">{{ labels }}</div>
  </div>
</template>

<script>
export default {
  props: {
    labels: String,
  },

  data() {
    return {}
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.goods-info-labels {
  margin-bottom: 0.2rem;

  .label {
    @include flex_center;
    width: max-content;
    height: 0.45rem;
    background: #f7f8fa;
    border-radius: 0.07rem;
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0.48rem;
    color: #5f7e95;
    margin-right: 0.2rem;
    padding: 0 0.16rem;
  }
}
</style>
